/* Publish by EComposer at 2025-01-14 04:35:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2dzb3y3y9t"]=  window.__ectimmers["ecom-2dzb3y3y9t"] || {};
if(!this.$el) { return; }

                const $el = this.$el;

                const read_more_btn = $el.querySelector('.ecom-text_view-more-btn');
                const read_less_btn = $el.querySelector('.ecom-text_view-less-btn');
                const el_content = $el.querySelector('.text-content.ecom-html');
                if(!el_content) { return; }

                if(read_more_btn) {
                    read_more_btn.addEventListener('click', () => {
                        el_content.classList.remove('ecom-text--is-mark');
                        el_content.style.maxHeight = "";
                        read_more_btn.style.display = "none";
                        read_less_btn.style.display = "";
                    })
                }

                if(read_less_btn) {
                    read_less_btn.addEventListener('click', () => {
                        el_content.classList.add('ecom-text--is-mark');
                        el_content.style.maxHeight = "var(--ecom-text-height)";
                        read_less_btn.style.display = "none";
                        read_more_btn.style.display = "";
                    })
                }

                    });
                    
                        document.querySelectorAll('.ecom-2dzb3y3y9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dzb3y3y9t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1tkexxjj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1tkexxjj8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dj9j8gt392o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dj9j8gt392o', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-svvopi05zec"]=  window.__ectimmers["ecom-svvopi05zec"] || {};
const $el = this.$el;
                const $this = this;
                if(!$el) return;
                const form = $el.querySelector('form');
                let link = this.settings.link_redirect;
                if(this.isLive) {
                    function ecomNewsletterRedirect(){
                        if(!link) return false;
                        let href = link.href;
                        if(href=='') return false;
                        let target = link.target;
                        let url = window.location.href;
                        if(url.includes('customer_posted=true')){
                            if(target === '_blank'){
                                window.open(href);
                            }
                            else{
                                window.location.href = href;
                            }
                        }
                    }
                    ecomNewsletterRedirect();
                    const regex = /(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;
                    if(this.settings.scroll_in_view) {
                        if(window.location.pathname.includes('challenge')) {
                            setTimeout(function() {
                                var element = document.querySelector(".shopify-challenge__container");
                                element.scrollIntoView();
                            }, 100);
                        }
                        else {
                            setTimeout(function() {
                                if(regex.test(location.search) || window.location.href.includes('customer_posted=true')) {
                                    $el.scrollIntoView();
                                }
                            }, 300);
                        }
                    }

                    if (regex.test(location.search)) {

                        if(form) {
                            form.querySelector('.ecom-shopify__newsletter-form-message.ecom-dn')
                            && form.querySelector('.ecom-shopify__newsletter-form-message.ecom-dn').classList.remove('ecom-dn');
                        }
                    };
                    if(form && form.dataset.ecTrackingId)
                    {
                        form.addEventListener('submit', function(){
                            if(window.Shopify && window.Shopify.analytics)
                            {
                                Shopify.analytics.publish("ec_custom_events",{
                                    "button_id": form.id,
                                    "tracking_id": form.dataset.ecTrackingId
                                })
                            }
                        },{once: true});
                    }

                    // Checkbox handle
                    let checkbox = $el.querySelector('.ecom-shopify__newsletter__verify-checkbox');
                    let checkbox_error = $el.querySelector('.ecom-shopify__newsletter__verify-error');
                    let submit_btn = $el.querySelector('.ecome-shopify__newsletter__button');
                    if(checkbox) {
                        submit_btn.addEventListener('click', function(e) {
                            if(checkbox.checked == false) {
                                e.preventDefault();
                                checkbox_error.classList.remove('ecom-dn');
                            } else {
                                checkbox_error.classList.add('ecom-dn');
                            }
                        })
                        checkbox.addEventListener('change', function(e) {
                            if(checkbox.checked)
                                checkbox_error.classList.add('ecom-dn');
                        })
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-svvopi05zec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svvopi05zec', settings: {"scroll_in_view":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g41t9z64mu"]=  window.__ectimmers["ecom-g41t9z64mu"] || {};
if (!this.$el) {
          return false;
        }
        const $el = this.$el;
        const $this = this;
        const $animation = this.settings.animation;
        const eventRunAnimation = new CustomEvent("animation", function() {
        });
        let $elementEdit = $el.querySelector(".ecom__heading");
        if ($elementEdit.querySelector("a")) {
          $elementEdit = $elementEdit.querySelector("a");
        }
        $elementEdit.addEventListener("animation", () => {
          headingAnimation();
        });
        $elementEdit.addEventListener("blur", function(e) {
          e.target.dispatchEvent(eventRunAnimation);
        });
        function headingAnimation() {
          if ($animation === "typing") {
            let playAnim = function() {
              setTimeout(function() {
                let animation = _this.settings?.animation;
                element.innerText = arr[textToBeTypedIndex].slice(0, index);
                if (isAdding) {
                  if (index > arr[textToBeTypedIndex].length) {
                    isAdding = false;
                    if (animation == "typing") {
                      setTimeout(function() {
                        playAnim();
                      }, 2e3);
                    }
                    return;
                  } else {
                    index++;
                  }
                } else {
                  if (index === 0) {
                    isAdding = true;
                    textToBeTypedIndex = (textToBeTypedIndex + 1) % arr.length;
                  } else {
                    index--;
                  }
                }
                playAnim();
              }, isAdding ? 120 : 60);
            };
            let element = $el.querySelector(".highlight-animation--typing");
            if (!element)
              return false;
            let arr = element.dataset.heading.split("|") || "";
            let index = 0, isAdding = true, textToBeTypedIndex = 0;
            const _this = $this;
            playAnim();
          }
          if ($animation === "smooth") {
            let playAnim = function() {
              let count = 0;
              let animationSmooth = window.__ectimmers["ecom-g41t9z64mu"]["c9c1d5mhs"] = setInterval(function() {
                if ($animation != "smooth") {
                  clearInterval(animationSmooth);
                }
                count++;
                elements.forEach((item, index) => {
                  if (count == elements.length) {
                    count = 0;
                  }
                  if (index == count) {
                    item.classList.add("is-active");
                  } else {
                    item.classList.remove("is-active");
                  }
                });
              }, 3e3);
            };
            let elements = $el.querySelectorAll(".heading-animation--smooth-item");
            if (!elements)
              return false;
            playAnim();
          }
        }
        headingAnimation();

                    });
                    
                        document.querySelectorAll('.ecom-g41t9z64mu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g41t9z64mu', settings: {"animation":"smooth"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wd6lf3zlju"]=  window.__ectimmers["ecom-wd6lf3zlju"] || {};
// if (this.isLive) {
                    const buttons = this.$el.querySelectorAll('.ecom-collection__layout-switch-item button');
                    const productGrid = document.querySelector('.ecom-collection__product--wrapper-items.ecom-collection-product__layout-grid');
                    if(buttons.length && productGrid) {
                        buttons.forEach(function(button) {
                            button.classList.remove('ecom-active-item');
                            if (button.dataset.col == productGrid.dataset.gridColumn && window.screen.width > 1024) {
                                button.classList.add('ecom-active-item');
                            }
                            if (button.dataset.col == productGrid.dataset.gridColumnTablet && window.screen.width > 767 && window.screen.width <= 1024) {
                                button.classList.add('ecom-active-item');
                            }
                            if (button.dataset.col == productGrid.dataset.gridColumnMobile && window.screen.width <= 767) {
                                button.classList.add('ecom-active-item');
                            }
                            button.addEventListener('click', function (e) {
                                const productGridNew = document.querySelector('.ecom-collection__product--wrapper-items.ecom-collection-product__layout-grid');
                                buttons.forEach(function(button) {
                                    button.classList.remove('ecom-active-item');
                                });
                                productGridNew.style.gridTemplateColumns = `repeat(${this.dataset.col},1fr)`;
                                this.classList.add('ecom-active-item');
                            });
                        })
                    }
                        
                // }

                    });
                    
                        document.querySelectorAll('.ecom-wd6lf3zlju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wd6lf3zlju', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7it4xv6rmlo"]=  window.__ectimmers["ecom-7it4xv6rmlo"] || {};
const $el = this.$el;
                if(!$el) return;
                if (this.isLive) {
                    const _this = this, enable_ajax = this.settings.enable_ajax;
                    const el_sort = $el.querySelector('.ecom-collection__sorting-wrapper');
                    if(!el_sort) return;
                    const page_type = el_sort.dataset.page ?? 'collection';
                    const class_wrapper = `.ecom-collection__product-main.ecom-collection_product_template_${page_type}`;
                     const ecomAjaxSorting = (function() {
                        return {
                            searchParamsInitial: window.location.search.slice(1),
                            searchParamsPrev: window.location.search.slice(1),
                            init() {
                                const selected = _this.$el.querySelector('.ecom-collection__sorting-select');
                                if(selected.length == 0) return;

                                const wrapper = selected.closest('.ecom-sections[data-section-id]');
                                const wrapper_product = wrapper.querySelector('.ecom-collection__product-wrapper');
                                if(!wrapper || !wrapper.dataset.sectionId) return;
                                this.selected = selected;
                                this.wrapper = wrapper;
                                this.sectionId = wrapper.dataset.sectionId;
                                this.wrapper_product = wrapper_product;
                                const $this = this;
                                this.selected.addEventListener('change', function(e){
                                    const params = window.location.search.replace('?', '').replace(/&sort_by=[^&]+/, '') + "&sort_by=" + e.target.value;
                                    const url = `${window.location.pathname}?section_id=${$this.sectionId}&${params}`;
                                    $this.handleLoadProduct(url, params);
                                });
                                this.setListeners();
                            },

                            setListeners() {
                                const onHistoryChange = (event) => {
                                const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
                                if (searchParams === this.searchParamsPrev) return;
                                const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
                                this.handleLoadProduct(url, searchParams, false)
                                }
                                window.addEventListener('popstate', onHistoryChange);
                            },

                            handleLoadProduct(fetch_url, searchParams, updateURLHash = true) {
                                this.searchParamsPrev = searchParams;
                                const _this = this;
                                const loadProduct = async function(url) {
                                const response = await fetch(url, {
                                    method: 'GET',
                                    headers: {
                                    'Content-Type': 'text/html'
                                    },
                                });
                                return response.text();
                                }
                                _this.wrapper_product.classList.add('ecom-doing-filter');

                                loadProduct(fetch_url).then(function(data) {
                                    const dom = document.createElement('div');
                                    dom.innerHTML = data;

                                    const product_wrapper = _this.wrapper_product.querySelector(class_wrapper);

                                    if(!product_wrapper) return;

                                    //product_wrapper.scrollIntoView({behavior: "smooth"});
                                    //Update product
                                    product_wrapper.innerHTML = dom.querySelector(class_wrapper).innerHTML;
                                    //Update URL
                                    if(updateURLHash) _this.updateURLHash(searchParams)
                                    //update filter
                                    //Render filter values

                                    product_wrapper.querySelector('.ecom-collection__product--wrapper-items') &&
                                    product_wrapper.dispatchEvent(new CustomEvent('ecom-products-init',{
                                        detail: {
                                            wrapper: product_wrapper
                                        }
                                    }))
                                })
                                .finally(function() {
                                _this.wrapper_product.classList.remove('ecom-doing-filter');
                                })
                            },

                            updateURLHash(searchParams) {
                                history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
                            },


                        }
                    })();

                    if(enable_ajax) {
                        ecomAjaxSorting.init();
                    }
                    else {
                        this.$el
                        .querySelector('[name="sort_by"]')
                        .addEventListener('change', function (e) {
                            const urlParams = new URLSearchParams(new URL(window.location).search);
                            const desiredParams = ['q', 'type', 'options'];
                            const filteredParams = {};

                            for (const [key, value] of urlParams) {
                                if (desiredParams.includes(key)) {
                                    filteredParams[key] = value;
                                }
                            }
                            for (const key in filteredParams) {
                                window.EComposer.queryParams[key] = filteredParams[key];
                            }
                            window.EComposer.queryParams.sort_by = e.target.value;
                            window.location.search = new URLSearchParams(
                                window.EComposer.queryParams
                            ).toString();
                        });
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-7it4xv6rmlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7it4xv6rmlo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-grce3y18uj6"]=  window.__ectimmers["ecom-grce3y18uj6"] || {};
if(!this.$el) return;
                const $el = this.$el;
                const imageParallax = $el.querySelector(".ecom-banner-use-parallax .ecom-parallax-background img");
                if(!imageParallax) return;
                const imageParent = imageParallax.parentNode;
                function isInViewport(element) {
                    const rect = element.getBoundingClientRect();
                    return (
                        // rect.top >= 0 &&
                        rect.bottom > 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) 
                    );
                }
                function parallaxImg(image) {
                    if(!image) return;
                    let speed = -1,
                        imgY = imageParent.offsetTop,
                        winY = window.scrollY ?? 0,
                        winH = window.innerHeight,
                        parentH = imageParent.clientHeight;
                    const winBottom = winY + winH;
                    
                        // if (winBottom > imgY && winY < imgY + parentH) {
                            const imgBottom = (winBottom - imgY) * speed;
                            const imgTop = winH + parentH;
                            const imgPercent = (imgBottom / imgTop) * 100 + (50 - speed * 50);
                            image.style.top = imgPercent + '%';
                            image.style.transform = `translate(-50%, -${imgPercent}%)`;
                        // }
                }
                function handleScrollParallax() {
                    imageParent.style.display = 'flex';
                    if(isInViewport(imageParent)) {
                        parallaxImg(imageParallax);
                    }
                }
                handleScrollParallax();
                document.addEventListener('scroll', handleScrollParallax);

                    });
                    
                        document.querySelectorAll('.ecom-grce3y18uj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grce3y18uj6', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ddbsayde33j"]=  window.__ectimmers["ecom-ddbsayde33j"] || {};
if (this.settings.link === "lightbox" && this.settings.lightbox === "yes" && window.EComModal && this.$el) {
          var popup_selector = this.$el.querySelector("[ecom-modal]");
          new window.EComModal(popup_selector, {
            cssClass: ["ecom-container-lightbox-" + this.id]
          });
        }
        let $el = this.$el;
        if (!$el)
          return;
        function isElementVisible(elementToBeChecked) {
          const rect = elementToBeChecked.getBoundingClientRect();
          return rect.top >= 0 && rect.left >= 0 && rect.bottom - elementToBeChecked.offsetHeight / 2 <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        }
        function handleScrollHighlight() {
          let $dom = $el.querySelector(".ecom-element.ecom-base-image");
          let coreRowColsEle = $el.closest(".core__row--columns");
          if ($dom) {
            if (isElementVisible($dom)) {
              $dom.classList.add("image-highlight");
              coreRowColsEle.setAttribute("style", "z-index: unset");
            } else {
              $dom.classList.remove("image-highlight");
              coreRowColsEle.setAttribute("style", "z-index: 1");
            }
          }
        }
        if (this.settings.highligh_on_viewport) {
          window.addEventListener("scroll", function() {
            handleScrollHighlight();
          });
        }

                    });
                    
                        document.querySelectorAll('.ecom-ddbsayde33j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddbsayde33j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q6itouyj0wf"]=  window.__ectimmers["ecom-q6itouyj0wf"] || {};
if (!this.$el) return;
                const $el = this.$el;
                const $this = this;
                const layout = this.settings.layout;
                let wrapper = $el.closest(".core__row--columns");
                const menu = $el.querySelector(".ecom-shopify__menu-list--mobile");
                const iconMenu = $el.querySelector(".ecom-menu__icon-humber"),
                    closeMenu = $el.querySelector(".ecom-menu-collapse-close--mobile");
                let filter_core_block = $el.closest("div.ecom-core.core__block") || "",
                    filter_core_column = $el.closest("div.ecom-column.ecom-core") || "",
                    menuLinks = $el.querySelectorAll(".ecom-shopify__menu-item--link");
                if (filter_core_block) {
                    filter_core_block.style.overflow = "visible";
                }
                if (menuLinks && menu) {
                    menuLinks.forEach(function (menuLink) {
                        menuLink.addEventListener("click", function () {
                            closeMenuResponsive();
                        });
                    });
                }
                if (iconMenu) {
                    iconMenu.addEventListener("click", openMenuResponsive);
                    closeMenu.addEventListener("click", closeMenuResponsive);
                    // document.addEventListener('keydown', escOutSideCloseQuickView);
                }
                while (wrapper) {
                    wrapper.style.zIndex = "100";
                    wrapper = wrapper.parentElement.closest(".core__row--columns");
                }
                function openMenuResponsive() {
                    if (!menu) return;
                    menu.parentNode.style.display = "block";
                    menu.classList.add("ecom-show");
                    //fix z-index on Editor
                    filter_core_block ? (filter_core_block.style.zIndex = "100") : "";
                    filter_core_column ? (filter_core_column.style.zIndex = "100") : "";

                    //add menu opened class to body
                    document.querySelector("body").classList.add("ecom-menu-opened");
                    setTimeout(function () {
                        document.addEventListener("click", clickOutSideCloseMenu);
                        document.addEventListener("keydown", escCloseMenu);
                    }, 500);
                }
                function clickOutSideCloseMenu(e) {
                    let element = e.target;
                    do {
                        if (element == menu) {
                            return;
                        }
                        element = element.parentNode;
                    } while (element);
                    if (element != menu) {
                        closeMenuResponsive();
                        document.removeEventListener("click", clickOutSideCloseMenu);
                        document.removeEventListener("keydown", escCloseMenu);
                    }
                }
                function escCloseMenu(e) {
                    if (e.isComposing || e.keyCode === 27) {
                        closeMenuResponsive();
                        document.removeEventListener("keydown", escCloseMenu);
                        document.removeEventListener("click", clickOutSideCloseMenu);
                    }
                }
                function closeMenuResponsive() {
                    menu.parentNode.style.display = "none";
                    menu.classList.remove("ecom-show");
                    //fix z-index on Editor
                    filter_core_block ? (filter_core_block.style.zIndex = "1") : "";
                    filter_core_column ? (filter_core_column.style.zIndex = "1") : "";
                    document.querySelector("body").classList.remove("ecom-menu-opened");
                    document.removeEventListener("keydown", escCloseMenu);
                    document.removeEventListener("click", clickOutSideCloseMenu);
                }
                //Hanlde collapsible menu
                let horizontal = $el.querySelector(
                        '.ecom-shopify__menu-list[data-menu-layout="horizontal"]'
                    ),
                    parrentLink = null;
                if (horizontal)
                    parrentLink = horizontal.querySelectorAll(
                        ".ecom-shopify__menu-item--has-children>.ecom-menu_item>.ecom-element--menu_title"
                    );
                if (parrentLink) {
                    parrentLink.forEach(function (link) {
                        link.addEventListener("click", function (e) {
                            e.preventDefault();
                        });
                    });
                }
                function hanldeCollapsible() {
                    var coll = $el.querySelectorAll(
                        ".ecom-shopify__menu-list .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"
                    );
                    var coll1 = $el.querySelectorAll(
                        ".ecom-shopify__menu-list--mobile .ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-list--mobile .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item"
                    );
                    if (!coll) return;
                    var i;
                    var isDefaultShowAll = "false";
                    var ecom_shopify_menu = $el.querySelector(".ecom-shopify__menu-wrapper");
                    if (ecom_shopify_menu && ecom_shopify_menu.dataset.showAll) {
                        var isDefaultShowAll = ecom_shopify_menu.dataset.showAll;
                    }
                    for (i = 0; i < coll.length; i++) {
                        if (layout === "horizontal" && !$this.isLive) {
                            coll[i].addEventListener("click", function (e) {
                                e.preventDefault();
                                // activeCollapsible(this);
                            });
                        } else if (layout === "horizontal" && $this.isLive) {
                            coll[i].addEventListener("click", function (e) {
                                e.stopPropagation();
                                // activeCollapsible(this);
                            });
                        } else if (layout === "vertical" || !$this.isLive) {
                            if (isDefaultShowAll && isDefaultShowAll == "true") {
                                activeCollapsible(coll[i]);
                            }
                            coll[i].addEventListener("click", function (e) {
                                e.preventDefault();
                                activeCollapsible(this);
                            });
                        }

                        if (coll1[i]) {
                            coll1[i].addEventListener("click", function (e) {
                                e.preventDefault();
                                // e.target.classList.toggle('ecom-text-active');
                                activeCollapsible(this);
                            });
                        }
                        function activeCollapsible(item) {
                            let content = item.nextElementSibling;
                            let parent_sub_menu = null;
                            if (item.classList.contains("ecom-item-active")) {
                                item.classList.remove("ecom-item-active");
                                if (content) {
                                    content.style.maxHeight = null;

                                    var child_menu_items =
                                        content.querySelectorAll(".ecom-menu_item");
                                    if (child_menu_items) {
                                        child_menu_items.forEach((item) => {
                                            var sibling_content = item.nextElementSibling;
                                            if (sibling_content) {
                                                sibling_content.style.maxHeight = null;
                                            }
                                            item.classList.remove("ecom-item-active");
                                        });
                                    }

                                    parent_sub_menu = item.closest(".ecom-shopify__menu-sub-menu");
                                    if (parent_sub_menu) {
                                        parent_sub_menu.style.maxHeight =
                                            parseInt(parent_sub_menu.style.maxHeight) -
                                            content.scrollHeight +
                                            "px";
                                    }
                                }
                            } else {
                                item.classList.add("ecom-item-active");
                                if (content) {
                                    parent_sub_menu = item.closest(".ecom-shopify__menu-sub-menu");
                                    if (parent_sub_menu) {
                                        parent_sub_menu.style.maxHeight =
                                            parseInt(parent_sub_menu.style.maxHeight) +
                                            content.scrollHeight +
                                            "px";
                                    }
                                    content.style.maxHeight = content.scrollHeight + "px";
                                }
                            }
                        }
                    }
                }
                hanldeCollapsible();

                    });
                    
                        document.querySelectorAll('.ecom-q6itouyj0wf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6itouyj0wf', settings: {"layout":"vertical"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d94oidshka"]=  window.__ectimmers["ecom-d94oidshka"] || {};
var $el = this.$el;
                if($el && this.isLive) {
                    var link = $el.querySelectorAll('.element-social-link:not(.element-social-link__custom)');

                    if(link.length) {
                        link.forEach(function(el) {
                            var href = el.getAttribute('href') || '#';
                            var new_href = href.replace('{current-link}', location.href);
                            el.setAttribute('href', new_href);
                        })
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-d94oidshka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d94oidshka', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l3lxqh1sgs"]=  window.__ectimmers["ecom-l3lxqh1sgs"] || {};
let $el = this.$el,
                        isLive = this.isLive,
                        close_filter = this.settings.close_filter ?? false;

                    if(!$el) return;

                    if(!isLive){
                        setTimeout(function(){
                            if($el.closest('.ecom-block')) {
                                $el.closest('.ecom-block').style.zIndex = 11;
                                $el.style.zIndex = 7;
                            }
                        },500);
                    }
                    if(!$el.querySelector('.ecom-collection__filters-wrapper')) return;
                    const _this = this,
                        page_type = $el.querySelector('.ecom-collection__filters-wrapper').dataset.page ?? 'collection',
                        typeFilter = this.settings.filter_type;
                    let list = $el.querySelectorAll('.ecom-collection__filters-group-list');

                    list.forEach((l) => {
                        if (l.childNodes.length) {
                            l.closest('.ecom-collection__filters-group').classList.remove(
                                'ecom-d-none'
                            );
                        }
                    });
                // trigger hidden_radio before submit
                function trigger_radio() {
                    this.querySelector(
                        ".ecom-collection__filters-radio--input-hidden"
                    ).checked = true;
                }
                let range_price_item = document.getElementsByClassName(
                    "ecom-collection__filters-group-radio"
                );
                range_price_item = Array.from(range_price_item);
                range_price_item.forEach((item) => {
                    item.addEventListener("click", trigger_radio);
                });
                const closeAllOther = this.settings.accordion_close ?? false;

                if (closeAllOther && this.settings.filter_type == 'collapse') {
                    const detailsElements = $el.querySelectorAll('.ecom-collection__filters-group');
                    if (detailsElements.length === 0) return;
                    detailsElements.forEach(function(details) {
                        details.addEventListener('click', function() {
                            detailsElements.forEach(function(otherDetails) {
                                if (otherDetails !== details) {
                                    otherDetails.removeAttribute('open');
                                }
                            });
                        });
                    });
                }
                //toggle
                function handleClickOutSide(e) { 
                    let element = e.target;
                    do {
                        if(element && element.classList && element.classList.contains('ecom-collection__filters-group--display')){
                            return;
                        }
                        element = element.parentNode;
                    }while(element);
                    if(!element || !element.classList.contains('ecom-collection__filters-group--display')) {
                        let details = $el.querySelectorAll('.ecom-filter-dropdown-desktop .ecom-collection__filters-group .ecom-collection__filters-group-summary');
                        if(details.length > 0) {
                            details.forEach(
                                (item) =>
                                    item
                                        .closest('.ecom-collection__filters-group')
                                        .classList.contains('active') &&
                                    item
                                        .closest('.ecom-collection__filters-group')
                                        .classList.remove('active')
                            );
                        }
                        document.removeEventListener('click', handleClickOutSide)
                    }
                    
                }
                function toggleDropdown () {
                        $el.querySelector('.ecom-collection__filters-dropdown') && $el.querySelector('.ecom-collection__filters-dropdown').classList.add(
                            'ecom-filter-dropdown-desktop'
                        );
                        let details = $el.querySelectorAll(
                            '.ecom-filter-dropdown-desktop .ecom-collection__filters-group .ecom-collection__filters-group-summary'
                        );
                        if (!details) {
                            return;
                        }
                        details.forEach((item) => {
                            let group = item.closest('.ecom-collection__filters-group');
                            let numMax = group.dataset.attrsMax;
                            let items = group.querySelectorAll(
                                '.ecom-collection__filters-group-list-item-max'
                            );
                            let popup = group.querySelector('.ecom-collection__filters-group--display ');
                            let btnMore = group.querySelector('.ecom-more-filter');
                            if (btnMore) {
                                btnMore.addEventListener('click', () => {
                                    showItem(items);
                                    btnMore.style.display = 'none';
                                });
                            }
                            if (items.length > 0 && numMax) {
                                numMax = parseInt(numMax);
                                showItem(items, numMax);
                            }

                            if(close_filter){if(group.classList.contains('active')) group.classList.remove('active')};
                            item.addEventListener('click', () => {
                                
                                if (!group.classList.contains('active')) {
                                    document.removeEventListener('click', handleClickOutSide)
                                    details.forEach(
                                        (item) =>
                                            item
                                                .closest('.ecom-collection__filters-group')
                                                .classList.contains('active') &&
                                            item
                                                .closest('.ecom-collection__filters-group')
                                                .classList.remove('active')
                                    );
                                    if(popup) {
                                        setTimeout(function(){
                                            document.addEventListener('click', handleClickOutSide);
                                        }, 200)
                                        group.classList.add('active');
                                        const {left, right} = group.getBoundingClientRect();
                                        if(window.innerWidth - left < 300) {
                                            popup.style.left = `-${300 - (window.innerWidth - left - 10)}px`
                                        }
                                    }
                                } else {
                                    group.classList.remove('active');
                                }
                            });
                        });
                    }

                function showItem (list, max) {
                    list.forEach((item, index) => {
                        if (max === undefined) {
                            item.style.display = 'block';
                        } else {
                            if (index < max) {
                                item.style.display = 'block';
                            } else {
                                item.style.display = 'none';
                            }
                        }
                    });
                }

                    const collapseMobile = this.settings.collapse_mobile;
                    if (this.settings.filter_type == 'dropdown') {
                        toggleDropdown();
                    }

                    const modal = $el.querySelector('#ecom-modal-block'),
                                btn = $el.querySelector('#button_menu_block'),
                                filter_core_block = modal ? modal.closest('div.ecom-core.core__block') : '',
                                filter_core_column = modal ? modal.closest('div.ecom-column.ecom-core') : '',
                                span = $el.querySelector('#ecom-modal-close');

                    const isMobile = window.matchMedia('only screen and (max-width: 1024px)');
                    //isMobile.addEventListener('change', conlapseCallback);
                    if (collapseMobile && isMobile.matches) {
                        conlapseCallback(isMobile);
                    }

                    function openSidebarFilter() {
                        modal.style.display = 'block';
                        //fix z-index on Editor
                        filter_core_block ? (filter_core_block.style.zIndex = '99') : '';
                        filter_core_column ? (filter_core_column.style.zIndex = '99') : '';

                        //add Filter opened class to body
                        document.querySelector('body').classList.add('ecom-filter-opened');

                    }
                    function closeSidebarFilter() {
                        modal.style.display = 'none';
                        document.querySelector('html').style.overflow = 'inherit';
                        document.body.style.overflow = 'inherit';
                        //fix z-index on Editor
                        filter_core_block ? (filter_core_block.style.zIndex = '1') : '';
                        filter_core_column ? (filter_core_column.style.zIndex = '1') : '';

                        setTimeout(function(){
                            document.querySelector('body').classList.remove('ecom-filter-opened');
                        }, 500);
                    }

                    function conlapseCallback (isMobile) {
                        // When user clicks button, open Modal
                        let content = $el.querySelectorAll('.ecom-collection__filters-group--display');
                        if (isMobile.matches) {
                            if (_this.settings.collapse_mobile && modal && btn && span) {
                                modal ? (modal.style.display = 'none') : '';
                                if (_this.settings.filter_type == 'dropdown') {
                                    content.forEach((item) => {
                                        item.style.position = 'relative'
                                    })
                                }
                                btn.addEventListener('click', () => {
                                    document.querySelector('html').style.overflow = 'hidden';
                                    document.body.style.overflow = 'hidden';
                                    openSidebarFilter()
                                });

                                // When user clicks Close (x), close Modal
                                span.addEventListener('click', () => {
                                    closeSidebarFilter()
                                });

                                // When user clicks anywhere outside of the Modal, close Modal
                                window.addEventListener('click', () => {
                                    if (event.target == modal) {
                                        closeSidebarFilter()
                                    }
                                });

                                //fix z-index on Editor
                                filter_core_block ? (filter_core_block.style.zIndex = '99') : '';
                                filter_core_column ? (filter_core_column.style.zIndex = '99') : '';
                            }
                        } else {
                            modal ? (modal.style.display = 'block') : '';
                            filter_core_block ? (filter_core_block.style.zIndex = '1') : '';
                            filter_core_column ? (filter_core_column.style.zIndex = '1') : '';
                            if (_this.settings.filter_type == 'dropdown') {
                                content && content.forEach((item) => {
                                    item.style.position = 'absolute'
                                })
                            }
                        }
                    }
                    // collapse
                    if (this.settings.filter_type == 'collapse' || this.settings.filter_type == 'push_down' && this.settings.collapse_mobile) {
                        // When user clicks button, open Modal
                        btn.addEventListener('click', () => {
                            if(this.settings.filter_type == 'collapse') {
                                document.querySelector('html').style.overflow = 'hidden';
                                document.body.style.overflow = 'hidden';
                            }
                            openSidebarFilter()
                        });

                        // When user clicks Close (x), close Modal
                        span.addEventListener('click', () => {
                            closeSidebarFilter()
                        });

                        // When user clicks anywhere outside of the Modal, close Modal
                        window.addEventListener('click', () => {
                            if (event.target == modal) {
                                closeSidebarFilter()
                            }
                        });
                    }
                    if(this.settings.collapse_mobile && this.settings.open_collapse_mobile && isMobile.matches) {
                        $el.querySelectorAll('.ecom-collection__filters-group').forEach(function(item) {
                            item.classList.add('active');
                        })
                    }
                    // handle push_down abcd
                    let height = 0, interval = 0, counter = 0, flag = 0, duration = 15;

                    //#2 the slideUp
                    function slideUp(element) {
                        if(height === 0) {
                            element.style.maxHeight = "100%";
                        }
                        height = element.offsetHeight; //declare the value of "height" variable
                        counter = height; //declare the value of "counter" variable
                        element.classList.remove('ecom-show--filter');
                        var subtractor = height/10;

                        //to hide the content of the element
                        element.style.overflow = "hidden";

                        //decreasing the height
                        interval = window.__ectimmers["ecom-l3lxqh1sgs"]["kmz1vu72f"] = setInterval(function () {

                        counter -= subtractor;
                        if (counter > 0) {
                            element.style.maxHeight = counter + "px";
                        } else {
                            element.style.maxHeight = 0;
                            clearInterval(interval);
                        }
                        }, duration);

                    }

                    //#3 the slideDown
                    function slideDown(element) {
                        var adder = height/10; //the height is global variable

                        //iteratively increase the height
                        element.classList.add('ecom-show--filter');
                        interval = window.__ectimmers["ecom-l3lxqh1sgs"]["sels4atr9"] = setInterval(function () {
                        counter += adder;
                        if (counter < height) {
                            element.style.maxHeight = counter + "px";
                        } else {
                            element.style.maxHeight = height + "px";
                            clearInterval(interval);
                        }
                        }, duration);

                    }
                    function handlePushDown(){
                        const push_down = $el.querySelector('.ecom-container-filter-list--wrapper[data-type="push_down"]');
                        if(push_down){
                            // if(isLive){
                                slideUp(push_down);
                                push_down.style.display = 'none';
                                push_down.style.opacity = '1';
                            // }else{
                            //     push_down.style.opacity = '1';
                            // }
                            btn.addEventListener('click', () => {
                                if(push_down.classList.contains('ecom-show--filter')){
                                    slideUp(push_down);

                                }
                                else {
                                    push_down.style.display = 'grid';
                                    slideDown(push_down);
                                }

                            });
                        }
                    }
                    handlePushDown();


                    function handlePriceSlider(reset = false) {
                        let minDollars = 1;
                        let maxDollars = 15000;

                        if (!$el.querySelector('.ecom-collection__filters-group-price')) {
                            return true;
                        }

                        let $max = $el.querySelector('.ecom-collection__filters-price-range-max'),
                            $min = $el.querySelector('.ecom-collection__filters-price-range-min');
                        let minSlider = $el.querySelector('#ecom-collection-filters--input-min');
                        let maxSlider = $el.querySelector('#ecom-collection-filters--input-max');

                        minDollars = parseFloat($min.getAttribute('min'));
                        maxDollars = parseFloat($max.getAttribute('max'));
                        if(reset === true) {
                            minSlider.value = minSlider.getAttribute('min');
                            maxSlider.value = maxSlider.getAttribute('max');
                            updateDollars();
                            return;
                        }
                        function formatMoney (number) {
                            return window.EComposer.formatMoney(number);
                        }

                        function updateDollars () {
                            let fromValue =
                                ((maxDollars - minDollars) * minSlider.value) / 100 + minDollars;
                            let toValue = ((maxDollars - minDollars) * maxSlider.value) / 100 + minDollars;
                            $min.value = fromValue.toFixed(2);
                            $max.value = toValue.toFixed(2);
                            $el.querySelector(
                                '#ecom-collection-filters--price-from'
                            ).innerHTML = `${formatMoney(Math.floor(fromValue * 100))}`;
                            $el.querySelector(
                                '#ecom-collection-filters--price-to'
                            ).innerHTML = `${formatMoney(Math.floor(toValue * 100))}`;
                        }
                        maxSlider.addEventListener('input', () => {
                            let minValue = parseInt(minSlider.value);
                            let maxValue = parseInt(maxSlider.value);

                            if (maxValue < minValue + 1) {
                                minSlider.value = maxValue - 1;

                                if (minValue === parseInt(minSlider.min)) {
                                    maxSlider.value = 1;
                                }
                            }
                            updateDollars();
                        });

                        minSlider.addEventListener('input', () => {
                            let minValue = parseInt(minSlider.value);
                            let maxValue = parseInt(maxSlider.value);

                            if (minValue > maxValue - 1) {
                                maxSlider.value = minValue + 1;

                                if (maxValue === parseInt(maxSlider.max)) {
                                    minSlider.value = parseInt(maxSlider.max) - 1;
                                }
                            }

                            updateDollars();
                        });
                    }

                    //Hanlde collapsible menu
                    function hanldeCollapsible() {
                        var coll = $el.querySelectorAll(".ecom-shopify__menu-item--has-children > .ecom-menu_item, .ecom-shopify__menu-child-link-item--has-children > .ecom-menu_item");
                        if(!coll) return;
                        var i;
                        var isDefaultShowAll = "false";
                        var ecom_shopify_menu = $el.querySelector(".ecom-shopify_menu");
                        if(ecom_shopify_menu && ecom_shopify_menu.dataset.showAll) {
                            var isDefaultShowAll = ecom_shopify_menu.dataset.showAll;
                        }


                        for (i = 0; i < coll.length; i++) {
                            if(isDefaultShowAll && isDefaultShowAll == "true") {
                                if(!coll[i].classList.contains('ecom-item-active')){
                                    activeCollapsible(coll[i]);
                                }
                            }
                            coll[i].addEventListener("click", function(e) {
                                e.preventDefault();
                                activeCollapsible(this);
                            });

                            function activeCollapsible(item) {
                                let content = item.nextElementSibling;
                                let parent_sub_menu = null;
                                if(item.classList.contains("ecom-item-active")) {
                                    item.classList.remove("ecom-item-active");
                                    if(content) {
                                        content.style.maxHeight = null;

                                        var child_menu_items = content.querySelectorAll('.ecom-menu_item');
                                        if(child_menu_items) {
                                            child_menu_items.forEach((item) => {
                                                var sibling_content = item.nextElementSibling;
                                                if(sibling_content) {
                                                    sibling_content.style.maxHeight = null;
                                                }
                                                item.classList.remove('ecom-item-active');
                                            });
                                        }

                                        parent_sub_menu = item.closest('.ecom-shopify__menu-sub-menu');
                                        if(parent_sub_menu) {
                                            parent_sub_menu.style.maxHeight = parseInt(parent_sub_menu.style.maxHeight) - content.scrollHeight + "px";
                                        }

                                    }
                                } else {
                                    item.classList.add("ecom-item-active");
                                    if (content) {
                                        parent_sub_menu = item.closest('.ecom-shopify__menu-sub-menu');
                                        if(parent_sub_menu) {
                                            parent_sub_menu.style.maxHeight = parseInt(parent_sub_menu.style.maxHeight) + content.scrollHeight + "px";
                                        }
                                        content.style.maxHeight = content.scrollHeight + "px";
                                    }
                                }
                            }
                        }
                    }

                    hanldeCollapsible();

                    const ecomAjaxFilter = (function() {
                        return {
                        searchParamsInitial: window.location.search.slice(1),
                        searchParamsPrev: window.location.search.slice(1),
                        init() {
                            const facetForms = $el.querySelectorAll('.ecom-collection__filters-form');
                            if(facetForms.length == 0) return;

                            const wrapper = facetForms[0].closest('.ecom-sections[data-section-id]');
                            const wrapper_product = facetForms[0].closest('.ecom-row.ecom-section');
                            if(!wrapper || !wrapper.dataset.sectionId) return;
                            this.facetForms = facetForms;
                            this.wrapper = wrapper;
                            this.sectionId = wrapper.dataset.sectionId;
                            this.wrapper_product = wrapper_product;

                            this.debouncedOnSubmit = this.debounce((event) => {
                            this.onSubmitHandler(event);
                            }, 100);

                            this.facetForms.forEach($form => $form.addEventListener('input', this.debouncedOnSubmit.bind(this)))
                            this.handleRemoveFilter();
                            this.setListeners();
                        },

                        setListeners() {
                            const onHistoryChange = (event) => {
                            const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
                            if (searchParams === this.searchParamsPrev) return;
                            const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
                            this.handleLoadProduct(url, searchParams, event, false)
                            }
                            window.addEventListener('popstate', onHistoryChange);
                        },

                        debounce(fn, wait) {
                            let t;
                            return (...args) => {
                            clearTimeout(t);
                            t = setTimeout(() => fn.apply(this, args), wait);
                            };
                        },

                        onSubmitHandler(event) {
                            event.preventDefault();
                            const forms = [];

                            this.facetForms.forEach((form) => {
                            forms.push(this.createSearchParams(form));
                            });

                            let params = forms.join('&');
                            const urlParams = new URLSearchParams(new URL(window.location).search);
                            const desiredParams = ['q', 'type', 'options', 'sort_by'];
                            const filteredParams = {};

                            for (const [key, value] of urlParams) {
                                if (desiredParams.includes(key)) {
                                    filteredParams[key] = value;
                                }
                            }

                            // Generate new URL params
                            const newUrlParams = new URLSearchParams(filteredParams);

                            // New url get q type options sort_by
                            const newUrl = `&${newUrlParams.toString()}`;
                            if(newUrl && newUrl != '') params += newUrl;
                            const url = `${window.location.pathname}?section_id=${this.sectionId}&${params}`;
                            this.handleLoadProduct(url, params, event);
                            let filter_push_down = $el.querySelector('.ecom-container-filter-list--wrapper[data-type="push_down"]');
                            if(filter_push_down && close_filter) slideUp(filter_push_down);

                        },

                        createSearchParams(form) {
                            const formData = new FormData(form);
                            return new URLSearchParams(formData).toString();
                        },

                        handleLoadProduct(fetch_url, searchParams, event, updateURLHash = true) {
                            const _this = this;
                            this.searchParamsPrev = searchParams;

                            const loadProduct = async function(url) {
                            const response = await fetch(url, {
                                method: 'GET',
                                headers: {
                                'Content-Type': 'text/html'
                                },
                            });
                            return response.text();
                            }
                            _this.wrapper_product.classList.add('ecom-doing-filter');

                            loadProduct(fetch_url).then(function(data) {
                                const dom = document.createElement('div');
                                dom.innerHTML = data;
                                let product_wrapper = null, idx = 0;
                                const class_wrapper = `.ecom-collection__product-main.ecom-collection_product_template_${page_type}`;
                                const product_wrappers = document.querySelectorAll(class_wrapper);
                                if(product_wrappers.length > 1){
                                    product_wrappers.forEach(function(wrapper, index) {
                                    if(product_wrapper) return;
                                     if(((window.screen.width > 1024 && !wrapper.closest('.hide-on-desktop'))
                                     || ((window.screen.width > 767 && window.screen.width <= 1024) && !wrapper.closest('.hide-on-tablet'))
                                     || (window.screen.width <= 767 && !wrapper.closest('.hide-on-mobile')))){
                                        product_wrapper = wrapper;
                                        idx = index
                                     }
                                   })
                                }
                                else {
                                    product_wrapper = product_wrappers[0];
                                }
                                if(!product_wrapper) return;

                                //product_wrapper.scrollIntoView({behavior: "smooth"});
                                //Update product
                                // const domFacetForms = dom.querySelectorAll(`.${_this.wrapper_product.dataset.id} .ecom-collection__filters-form`);
                                // const dom_wrapper_product = domFacetForms[0].closest('.ecom-row.ecom-section');
                                let result_products = dom.querySelectorAll(class_wrapper);
                                // let result_products = dom_wrapper_product.querySelectorAll(class_wrapper);
                                // if(result_products.length == 0) {
                                //     result_products = dom.querySelectorAll(class_wrapper);
                                // }
                                product_wrapper.innerHTML = result_products && result_products[idx].innerHTML;
                                //Update URL
                                if(updateURLHash) _this.updateURLHash(searchParams)
                                //update filter
                                _this.renderFilters(dom, event);
                                //Render filter values
                                _this.renderActiveFacets(dom);

                                product_wrapper.querySelector('.ecom-collection__product--wrapper-items') &&
                                product_wrapper.dispatchEvent(new CustomEvent('ecom-products-init',{
                                    detail: {
                                        wrapper: product_wrapper
                                    }
                                }))
                            })
                            .finally(function() {
                            if(typeFilter === 'collapse' || ((typeFilter === 'block' || typeFilter ==='dropdown') && window.screen.width < 1025 && collapseMobile) ) {
                                if(close_filter) closeSidebarFilter();
                            }
                            if(window.EComposer && window.EComposer.initButtonWishlist) window.EComposer.initButtonWishlist();
                            _this.wrapper_product.classList.remove('ecom-doing-filter');
                            toggleDropdown();
                            })
                        },

                        updateURLHash(searchParams) {
                            history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
                        },

                        renderActiveFacets(html) {
                            const resultFacetElementSelectors = html.querySelector('.ecom-collection__filters-applied-block');
                            const activeFacetElementSelectors = this.wrapper_product.querySelector('.ecom-collection__filters-applied-block');
                            const filterValueElement = this.wrapper_product.querySelectorAll('.ecom-collection__filter-values');

                            if (!activeFacetElementSelectors && resultFacetElementSelectors) {
                                this.facetForms.forEach( $form => {
                                    $form.prepend(resultFacetElementSelectors);
                                })
                            } else if(activeFacetElementSelectors && resultFacetElementSelectors) {
                                activeFacetElementSelectors.innerHTML = resultFacetElementSelectors.innerHTML;
                            } else if(activeFacetElementSelectors && !resultFacetElementSelectors) {
                                this.facetForms.forEach( $form => {
                                    $form.querySelector('.ecom-collection__filters-applied-block')
                                    && $form.querySelector('.ecom-collection__filters-applied-block').remove();
                                })
                            }

                            if(filterValueElement.length > 0) {
                            filterValueElement.forEach(filter => {
                                if(resultFacetElementSelectors) {
                                filter.innerHTML = resultFacetElementSelectors.querySelector('.ecom-collection-filters--active_values').innerHTML;
                                } else {
                                filter.innerHTML = '';
                                }
                            })
                            }

                        },

                        renderFilters(dom, event) {
                            const facetDetails = dom.querySelectorAll('.ecom-js-filter');
                            const matchesIndex = (element) => {
                                if(event.target === window) return false;
                                const jsFilter = event ? event.target.closest('.ecom-js-filter') : undefined;
                                return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
                            }

                            const facetsToRender = Array.from(facetDetails);
                            const countsToRender = Array.from(facetDetails).find(matchesIndex);

                            facetsToRender.forEach((element) => {
                                this.wrapper_product.querySelector(`.ecom-js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
                            });

                            //Render filter active values
                            renderActiveFacets(dom, this.wrapper_product);

                            //render filter selected
                            if (countsToRender) renderCounts(countsToRender, event.target.closest('.ecom-js-filter'));

                            function renderActiveFacets(html, wrapper) {

                                const activeFacetsElement = html.querySelector('.ecom-collection-filters--active_values-list');
                                const wrapperActiveFacetsElement = wrapper.querySelector('.ecom-collection-filters--active_values-list');
                                if (!activeFacetsElement || !wrapperActiveFacetsElement) return;
                                wrapperActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
                            }

                            function renderCounts(source, target) {
                                if(!target) return;

                                const targetElement = target.querySelector('.ecom-collection__filters-group--selected');
                                const sourceElement = source.querySelector('.ecom-collection__filters-group--selected');

                                const targetElementAccessibility = target.querySelector('.ecom-collection__filters-group-summary');
                                const sourceElementAccessibility = source.querySelector('.ecom-collection__filters-group-summary');
                                if (sourceElement && targetElement) {
                                    target.querySelector('.ecom-collection__filters-group--selected').outerHTML = source.querySelector('.ecom-collection__filters-group--selected').outerHTML;
                                }

                                if (targetElementAccessibility && sourceElementAccessibility) {
                                    target.querySelector('.ecom-collection__filters-group-summary').outerHTML = source.querySelector('.ecom-collection__filters-group-summary').outerHTML;
                                }
                            }
                        },

                        handleRemoveFilter() {
                            this.facetForms.forEach($form => {
                                $form.addEventListener('click', closeFilter.bind(this))
                            })

                            function closeFilter(event) {
                            if(event.target.closest('.ecom-collection__filters-group-list-item-clear') || event.target.closest('.ecom-collection__filters-group-reset-filter')) {
                                event.preventDefault();
                                const link = event.target.closest('.ecom-collection__filters-group-list-item-clear') || event.target.closest('.ecom-collection__filters-group-reset-filter');
                                if(!link.href) return;

                                let searchParams = link.href.indexOf('?') == -1 ? '' : link.href.slice(link.href.indexOf('?') + 1);
                                let sorting = window.location.search.match(/&sort_by=\S*/gm) && window.location.search.match(/&sort_by=\S*/gm).length && window.location.search.match(/&sort_by=\S*/gm)[0];
                                if(sorting) searchParams += sorting;
                                const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
                                this.handleLoadProduct(url, searchParams, event);
                                handlePriceSlider(true);
                            }
                            }
                        }

                        }
                    })();

                    if (isLive) {
                        handlePriceSlider();

                        if(this.settings.enable_ajax) {
                            ecomAjaxFilter.init();
                        } else {
                            this.$el.querySelector('.ecom-collection__filters-form')
                            .addEventListener('change', function () {
                                if(page_type == 'search') {
                                    const urlParams = new URLSearchParams(new URL(window.location).search);
                                    const desiredParams = ['q', 'type', 'options', 'sort_by'];
                                    const filteredParams = {};

                                    for (const [key, value] of urlParams) {
                                        if (desiredParams.includes(key)) {
                                            filteredParams[key] = value;
                                        }
                                    }
                                    for (const key in filteredParams) {
                                        if (filteredParams.hasOwnProperty(key)) {
                                            const input = document.createElement('input');
                                            input.type = 'hidden'; // hoặc có thể sử dụng 'text' tùy thuộc vào yêu cầu
                                            input.name = key;
                                            input.value = filteredParams[key];
                                            this.appendChild(input);
                                        }
                                    }
                                    this.submit();
                                }
                                else {
                                    this.submit()
                                }
                            });


                        }
                    }

                    });
                    
                        document.querySelectorAll('.ecom-l3lxqh1sgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l3lxqh1sgs', settings: {"close_filter":false,"filter_type":"collapse","collapse_mobile":true,"enable_ajax":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9spsw6nogb"]=  window.__ectimmers["ecom-9spsw6nogb"] || {};
let $el = this.$el
                if(!$el) return;
                let flagInfinite = true;
                let  $doms = $el.querySelectorAll(".ecom-collection__product-variants"),
                    isLive = this.isLive,
                    showFeaturedMedia = this.settings.show_featured_media ?? false,
                    sale_badge = this.settings.bage_sale ?? '',
                    show_progress_pagination = this.settings.enable_progress_pagination ?? false,
                    price_type = this.settings.price_type;
                let type_pagination = 'bullets';
                const slider_center = this.settings.slider_center,
                    slider_center__tablet = this.settings.slider_center__tablet,
                    slider_center__mobile = this.settings.slider_center__mobile;
                if(this.settings.slider_pagination_style === 'progress') type_pagination = 'progressbar'
                const saleBadgetType = this.settings.sale_badge_type;
                let slider_speed = this.settings.slider_speed,
                    slider_speed__tablet = this.settings.slider_speed__tablet,
                    slider_speed__mobile = this.settings.slider_speed__mobile;
                // step up/down quantity input
                const handleResponsive = function(settings, optionSwiper = {}, option='') {
                    if(window.innerWidth > 1024 && settings[0]) {
                        optionSwiper[`${option}`] = settings[0];
                    }
                    if(window.innerWidth <= 1024 && window.innerWidth > 768 && settings[1]) {
                        optionSwiper[`${option}`] = settings[1];
                    }
                    else if(settings[0]) {
                        optionSwiper[`${option}`] = settings[0];
                    }
                    if (window.innerWidth < 768 && settings[2]) {
                        optionSwiper[`${option}`] = settings[2];
                    }
                    else if(settings[1]) {
                        optionSwiper[`${option}`] = settings[1];
                    }
                    else if(settings[0]) {
                        optionSwiper[`${option}`] = settings[0];
                    }
                    return optionSwiper;
                }
                let $items = $el.querySelectorAll(".ecom-collection__product-item");
                if($items){
                    $items.forEach(function(item){
                        let $quantity = item.querySelector(".ecom-collection__product-quantity-input");
                        let $plus = item.querySelector(".ecom-collection__quantity-controls-plus");
                        let $minus = item.querySelector(".ecom-collection__quantity-controls-minus");
                        if($minus){
                            $minus.addEventListener('click', function(){
                                $quantity.stepDown();
                                $quantity.dispatchEvent(new Event('change'));
                            })
                        }
                        if($plus){
                            $plus.addEventListener('click', function(){
                                $quantity.stepUp();
                                $quantity.dispatchEvent(new Event('change'));
                            })
                        }
                        if($quantity) {
                            $quantity.addEventListener('change', function(e){
                                let tagA = item.querySelector('a.ecom-collection__product-submit');
                                if(e.target.value > parseInt(e.target.max)){
                                    e.target.value = parseInt(e.target.max);
                                }
                                if(tagA){
                                    let link = tagA.getAttribute('href');
                                    tagA.setAttribute('href', link.replace(/quantity=(\d*)/gm, `quantity=${e.target.value}`));
                                }

                            })
                        }
                    });
                }
                function handleProgressPagination(ajax = false, clickLoadMore) {
                    // ecom-pagination-progress-bar--wrapper
                    // .ecom-paginate__progress-text

                    const track = $el.querySelector('.ecom-paginate__progress-bar--outner'),
                          progress = $el.querySelector('.ecom-paginate__progress-bar--inner'),
                          text = $el.querySelector('.ecom-paginate__progress-text');
                    if(!show_progress_pagination || !isLive || !track || !progress || !text) return
                    let {total, initProduct} = track && track.dataset,
                        textInner = text && text.dataset.text,
                        count = 0,
                        start = 1,
                        end = 0,
                        percent = 0;
                    initProduct = parseInt(initProduct);
                    if(!ajax) {
                        if(window.location.href.match(/page=\d*/gm)){
                            const urlObject = new URL(window.location.href);
                            count = urlObject.searchParams.get("page");
                            if(count === 1 ) {
                                start = 1;
                            }
                            else {
                                start = initProduct * (count-1) + 1;
                            }
                        }
                        end = start + initProduct - 1;
                    }
                    else {
                        start = 1;
                        end = initProduct * clickLoadMore;
                    }
                    if(end > total) end = total;
                    percent = Math.round((end / total) * 100);
                    progress.style.width = `${percent}%`;
                    textInner = textInner.replace('{_start}', start);
                    textInner = textInner.replace('{_end}', end);
                    textInner = textInner.replace('{_total}', total);
                    text.innerText = textInner;
                }
                handleProgressPagination(false, 1);
                function selectCallback(variant, selector) {

                    var $wrapper =  selector.variantIdField.closest(".ecom-collection__product-item");
                    let $submit = $wrapper.querySelector(".ecom-collection__product-submit");
                    let $quantity = $wrapper.querySelector(".ecom-collection__product-quantity-input");
                    let $price = $wrapper.querySelector(".ecom-collection__product-price");
                    let $price_regular = $wrapper.querySelector(".ecom-collection__product-price--regular");
                    let $ground_price = $wrapper.querySelector(".ecom-unit-price");
                    if($price_regular) {
                        $price_regular.classList.add("ecom-collection__product--compare-at-price");
                    }
                    let $bage_sale = $wrapper.querySelector(".ecom-collection__product-price--bage-sale");
                    let $badge_sale = $wrapper.querySelector('.ecom-collection__product-badge--sale');
                    let $badge_soldout = $wrapper.querySelector('.ecom-collection__product-badge--sold-out');
                    let $sku_wrapper = $wrapper.querySelector(".ecom-collection__product-item-sku-element");
                    let sale = "";
                    if(variant === null || ($wrapper.hasAttribute('ec-variant-init') && price_type === 'first_price')) {
                        let $selector = $wrapper.querySelector('select[name="variant_id"]'),
                        $json = $wrapper.querySelector(".product-json");

                        let product = null;
                        try {
                            product = JSON.parse($json.innerHTML);
                        } catch (e) {
                            return 1;
                        }
                        if($wrapper.hasAttribute('ec-variant-init') && price_type === 'first_price') {
                            $wrapper.removeAttribute('ec-variant-init');
                            variant = product.variants.find( v => v.available);
                            if(variant == undefined) variant = product.variants[0]
                        } else {
                            let tmp = $wrapper.querySelector("select#" + $selector.id + "-option-0" );
                            if(!tmp) {
                                return;
                            }
                            const colorValue = tmp.value;
                            if(colorValue) {
                                product.variants.forEach(function(v) {
                                    if(v.options.includes(colorValue)) {
                                        variant = v;
                                        return;
                                    }
                                })
                            }
                        }

                    }
                    if (variant) {
                        if($price) {
                            $price.innerHTML = window.EComposer.formatMoney(variant.price);
                        }
                        if($price_regular) {
                            $price_regular.innerHTML = window.EComposer.formatMoney(variant.compare_at_price);
                        }
                        if($ground_price) {
                            if(variant.unit_price) {
                                $ground_price.style.display = 'block';
                            }
                            else {
                                $ground_price.style.display = 'none';
                            }
                            const $unit_price = $ground_price.querySelector('.ecom-ground-price_unit-price');
                            if($unit_price) {
                                $unit_price.innerHTML = window.EComposer.formatMoney(
                                    variant.unit_price
                                );
                            }
                        }
                        if (variant.compare_at_price > variant.price) {
                            if($price_regular) {
                                $price_regular.style.display = 'inherit';
                            }
                            let text = '';
                            text = $el.querySelector(".ecom-collection__product-main").dataset.sale;
                            if($el.querySelector(".ecom-collection__product-main").dataset.translate == 'false') {
                                text = sale_badge;
                            }
                            if($badge_sale && $badge_soldout) {
                                $badge_sale.style.display = 'block';
                                $badge_soldout.style.display = 'none';
                            }
                            if (saleBadgetType === 'amount') {

                                sale = variant.compare_at_price - variant.price;
                                if($bage_sale)
                                {
                                    $bage_sale.style.display = 'inherit';
                                    $bage_sale.innerHTML = text.replace(
                                        /\{{.*\}}/g,
                                        window.EComposer.formatMoney(sale)
                                    )
                                }


                            } else {
                                sale =
                                    ((variant.compare_at_price - variant.price) * 100) /
                                    variant.compare_at_price;
                                if($bage_sale)
                                {
                                    $bage_sale.style.display = 'inherit';
                                    $bage_sale.innerHTML = (text.replace(/\{{.*\}}/g, Math.round(sale)));
                                }
                            }
                        } else {
                            if($price_regular) {
                                $price_regular.style.display = 'none';
                            }
                            if($badge_sale && $badge_soldout) {
                                $badge_sale.style.display = 'none';
                                $badge_soldout.style.display = 'none';
                            }
                            if($bage_sale)
                            {
                                $bage_sale.style.display = 'none';
                                $bage_sale.innerHTML ='';
                            }
                        }
                        if($sku_wrapper)
                        {
                            if(variant.sku) {
                                $sku_wrapper.querySelector('.ecom-collection__product-item-sku').innerHTML = variant.sku;
                                $sku_wrapper.style.display = 'flex';
                            } else {
                                $sku_wrapper.style.display = 'none';
                            }
                        }

                        if (variant.featured_image) {
                            let $image = $wrapper.querySelector(".ecom-collection__product-media img");
                            //let $second  = $wrapper.querySelector('.ecom-collection__product-secondary-media');
                            // if($second)
                            // {
                            //     $image = $second;
                            // }
                            if(!showFeaturedMedia) {
                                let $parent = $image.closest("div");
                                $parent.classList.add("ecom-product-image-loading");
                                $image.setAttribute("src", variant.featured_image.src);
                                $image.removeAttribute("srcset");
                                $image.addEventListener('load', function() {
                                    $parent.classList.remove("ecom-product-image-loading");
                                })
                            }
                        }

                        if (variant.options.length) {
                            /* Fix auto select avaiable variant
                            if(!showFeaturedMedia) {
                                for (var i = 0; i < variant.options.length; i++) {
                                    $wrapper.querySelectorAll(`.ecom-collection__product-swatch-item[data-option-index="${i}"][data-value="${
                                        encodeURI(variant.options[
                                            i
                                        ])
                                    }"]`)
                                        .forEach(function (el) {
                                            let els = el.parentNode.children;
                                            for(let j=0;j<els.length;j++) {
                                                els[j].classList.remove('ecom-product-swatch-item--active');
                                            }
                                            el.classList.add('ecom-product-swatch-item--active');
                                        })

                                    $wrapper
                                        .querySelectorAll(
                                            `select.ecom-collection__product-swatch-select[data-option-index="${i}"]`
                                        )
                                        .forEach(function(el){
                                            if(el.value) {
                                                el.value = (variant.options[i]);
                                            }
                                        })
                                }
                            }
                            */
                        }
                        if($wrapper.querySelector(".ecom-collection__product-submit")) {
                            if(variant.available) {
                                const wrapper = $submit.closest('.ecom-collection__product--wrapper-items');
                                if(wrapper.dataset.iconAdd) {
                                    $submit.querySelector(".ecom-collection__product-add-cart-icon") &&
                                    ($submit.querySelector(".ecom-collection__product-add-cart-icon").innerHTML=wrapper.dataset.iconAdd);
                                }
                                if (!variant.inventory_management || (variant.inventory_management && variant.inventory_quantity > 0)) {
                                    $submit.removeAttribute('disabled');
                                    if($quantity){
                                        let qty_wrapper = $quantity.closest('.ecom-collection__product-quantity--wrapper')
                                        if(qty_wrapper) qty_wrapper.style.display = 'flex';
                                        $quantity.style.display = 'flex';
                                        !variant.inventory_management ? $quantity.max = 9999 : $quantity.max = variant.inventory_quantity;
                                    };
                                    $submit.classList.add("ecom-collection__product-form__actions--add");
                                    $submit.classList.remove('ecom-collection__product-form__actions--soldout');
                                    $submit.classList.remove('ecom-collection__product-form__actions--unavailable');
                                    $submit.querySelector(".ecom-add-to-cart-text").innerHTML = $submit.getAttribute("data-text-add-cart");
                                }
                                else if (variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0){
                                    $submit.removeAttribute('disabled');
                                    if($quantity){
                                        let qty_wrapper = $quantity.closest('.ecom-collection__product-quantity--wrapper')
                                        if(qty_wrapper) qty_wrapper.style.display = 'flex';
                                        $quantity.max = 9999;
                                        $quantity.style.display = 'flex';
                                    }
                                    $submit.classList.add("ecom-collection__product-form__actions--add");
                                    $submit.classList.remove('ecom-collection__product-form__actions--soldout');
                                    $submit.classList.remove('ecom-collection__product-form__actions--unavailable');
                                    $submit.querySelector(".ecom-add-to-cart-text").innerHTML = $submit.getAttribute("data-text-pre-order");
                                }
                                $submit.dataset.childName="add_to_cart_button";
                                $submit.dataset.childTitle="Add to cart button";
                            }
                            else {
                                if($badge_sale && $badge_soldout) {
                                    $badge_sale.style.display = 'none';
                                    $badge_soldout.style.display = 'block';
                                }
                                isLive ? $submit.setAttribute('disabled', 'disabled') : null;
                                if($quantity){
                                    let qty_wrapper = $quantity.closest('.ecom-collection__product-quantity--wrapper')
                                    if(qty_wrapper) qty_wrapper.style.display = 'none';
                                    $quantity.style.display = 'none';
                                }
                                const wrapper = $submit.closest('.ecom-collection__product--wrapper-items');
                                if(wrapper.dataset.iconSoldout) {
                                    $submit.querySelector(".ecom-collection__product-add-cart-icon") && ($submit.querySelector(".ecom-collection__product-add-cart-icon").innerHTML=wrapper.dataset.iconSoldout);
                                }
                                $submit.classList.add("ecom-collection__product-form__actions--soldout");
                                $submit.classList.remove("ecom-collection__product-form__actions--add");
                                $submit.classList.remove("ecom-collection__product-form__actions--unavailable");
                                $submit.querySelector(".ecom-add-to-cart-text").innerHTML = $submit.getAttribute("data-text-sold-out");
                                $submit.dataset.childName="sold_out_button";
                                $submit.dataset.childTitle="Sold out button";
                            }
                        }
                    } else {
                        $price.html = window.EComposer.formatMoney(0);
                        if($price_regular) {
                            $price_regular.innerHTML = window.EComposer.formatMoney(0);
                            $price_regular.style.display = 'none';
                        }

                        if($submit) {
                            $submit.setAttribute('disabled','disabled');
                            $submit.classList.add("ecom-collection__product-form__actions--unavailable");
                            $submit.classList.remove("ecom-collection__product-form__actions--add");
                            $submit.classList.remove("ecom-collection__product-form__actions--soldout");
                            $submit.querySelector(".ecom-add-to-cart-text").innerHTML = $submit.getAttribute("data-text-unavailable");
                        }
                    }
                }

                function executeShopifyOptionSelectors($dom) {
                    $dom.classList.add('ecom-swatch-init');
                    let $form = $dom.querySelector(".ecom-collection__product-form");
                    if(!$form) return;

                    let $selector = $form.querySelector('select[name="variant_id"]'),
                        $json = $dom.querySelector(".product-json");

                    let product = null;
                    try {
                        product = JSON.parse($json.innerHTML);
                    } catch (e) {
                        return 1;
                    }
                    if(window.EComposer && window.EComposer.OptionSelectors) {
                        new window.EComposer.OptionSelectors($selector.id, {
                            product: product,
                            onVariantSelected: selectCallback,
                            enableHistoryState: false
                        });
                    }

                    $dom.querySelectorAll(".ecom-collection__product-swatch-item").forEach(function (el) {
                        el.addEventListener("click", function () {
                            showFeaturedMedia = false;
                            var $this = this.closest('li');
                            if ($this.classList.contains("ecom-product-swatch-item--active")) {
                                return false;
                            }
                            $this.parentNode.querySelectorAll(".ecom-product-swatch-item--active").forEach(function (el) {
                                el.classList.remove("ecom-product-swatch-item--active");
                            });

                            $this.classList.add("ecom-product-swatch-item--active");

                            var index = $this.getAttribute("data-option-index");
                            var value = $this.getAttribute("data-value");
                            let tmp = $dom.querySelector("select#" + $selector.id + "-option-" + index);
                            tmp.value = value;
                            tmp.dispatchEvent(new Event("change"));

                        });
                    });
                    $dom.querySelectorAll("select.ecom-collection__product-swatch-select").forEach(function (elm) {
                        elm.addEventListener("change", function () {
                            var $this = this;
                            var index = $this.getAttribute("data-option-index");
                            var value = $this.value;
                             $dom.querySelectorAll("select#" + $selector.id + "-option-" + index).forEach(function (el) {
                                el.value = value;
                                el.dispatchEvent(new Event("change"));

                             })
                        });
                    });

                }
                if (this.settings.layout === "slider") {
                    let el = this.$el;
                    let product_container = el.querySelector(".ecom-collection__product-container");
                    handleSlider(el);
                    product_container.addEventListener('ecom-products-init-slider', function (e) {
                        handleSlider(e.detail.wrapper);
                    });
                    function handleSlider($el) {
                           let  $container = $el.querySelector(".ecom-swiper-container"),
                            optionSwiper = $container && $container.dataset.optionSwiper;
                        if (!optionSwiper) {
                            return;
                        }
                        optionSwiper = JSON.parse(optionSwiper);
                        optionSwiper.pagination = {
                            el: $el.querySelector(".ecom-swiper-pagination"),
                            type: type_pagination,
                            clickable: true
                        };
                        optionSwiper.navigation = {
                            nextEl: $el.querySelector(".ecom-swiper-button-next"),
                            prevEl: $el.querySelector(".ecom-swiper-button-prev")
                        };
                        optionSwiper.autoHeight = false;
                        optionSwiper.on = {
                            init: function() {
                                this.el.classList.add('ecom-swiper-initialized');
                            }
                        }
                        let settings = [slider_speed, slider_speed__tablet, slider_speed__mobile];
                        if(!isLive) {
                            setTimeout(function() {
                                optionSwiper = handleResponsive(settings, optionSwiper, 'speed');
                                let settings_center = [slider_center, slider_center__tablet, slider_center__mobile];
                                optionSwiper = handleResponsive(settings_center, optionSwiper, 'centeredSlides');
                                new window.EComSwiper($container, optionSwiper);
                            },200)
                        }
                        else {
                            optionSwiper = handleResponsive(settings, optionSwiper, 'speed');
                            let settings_center = [slider_center, slider_center__tablet, slider_center__mobile];
                            optionSwiper = handleResponsive(settings_center, optionSwiper, 'centeredSlides');
                            const swiper = new window.EComSwiper($container, optionSwiper);
                            if(optionSwiper.autoplay.enabled) {
                                swiper.on('touchStart', function(swiper, event) {
                                    swiper.params.speed = 300;
                                    swiper.autoplay.stop();
                                });
                                swiper.on('touchEnd', function(swiper, event) {
                                    if(window.innerWidth > 1024 && slider_speed) {
                                        swiper.params.speed = slider_speed;
                                    }
                                    if(window.innerWidth <= 1024 && window.innerWidth > 768 && slider_speed__tablet) {
                                        swiper.params.speed = slider_speed__tablet;
                                    }
                                    else if(slider_speed) {
                                        swiper.params.speed = slider_speed;
                                    }
                                    if (window.innerWidth < 768 && slider_speed__mobile) {
                                        swiper.params.speed = slider_speed__mobile;
                                    }
                                    else if(slider_speed__tablet) {
                                        swiper.params.speed = slider_speed__tablet;
                                    }
                                    else if(slider_speed) {
                                        swiper.params.speed = slider_speed;
                                    }
                                    // swiper.params.speed = handleResponsive(settings, optionSwiper, 'speed');
                                    swiper.autoplay.start();
                                });
                            }
                        }
                    }

                }
                $doms.forEach(executeShopifyOptionSelectors);

                const handleQuickShopBtn = function($wraper) {
                    $wraper.querySelectorAll(".ecom-collection__product-form__actions--quickshop").forEach(function (el) {
                        el.addEventListener("click", function (e) {
                            this.style.display = "none";
                            let $item = this.closest(".ecom-collection__product-item");

                            $item.querySelectorAll('.ecom-collection__product-variants').forEach(function(elm){
                                elm.classList.add('ecom-active');
                            })
                            $item.querySelectorAll(".ecom-collection__product-quick-shop-wrapper").forEach(function(elm){
                                elm.style.display = "inherit";
                            })
                        });
                    });

                    $wraper.querySelectorAll(".ecom-collection__product-close").forEach(function (el) {
                        el.addEventListener("click", function (e) {
                            let $item = this.closest(".ecom-collection__product-item");
                            $item.querySelectorAll('.ecom-collection__product-variants').forEach(function(elm){
                                elm.classList.remove('ecom-active');
                            })
                            $item.querySelectorAll(".ecom-collection__product-quick-shop-wrapper").forEach(function(elm){
                                elm.style.display = "none";
                            })
                            $item.querySelectorAll(".ecom-collection__product-form__actions--quickshop").forEach(function(elm){
                                elm.style.display = "inherit";
                            })
                        });
                    });
                }

                handleQuickShopBtn($el);
                /**
                 * Countdown
                 */
                const $main = $el.querySelector(".ecom-collection__product-main");
                let trans = $main.dataset,
                    shows = $main.dataset.countdownShows;
                const regex = /\[([^\]]+)\]/gm;
                var format = "";
                if (shows.indexOf("week") >= 0 && trans.week) {
                    let number = "";
                    let text = trans.week.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `
                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--week">
                                <span class="ecom-collection__product-time--number">
                                    ${number}
                                </span>
                                <span class="ecom-collection__product-time--label">
                                    ${text}
                                </span>
                            </div>`;
                }
                if (shows.indexOf("day") >= 0 && trans.day) {
                    let number = "";
                    let text = trans.day.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--day">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div> `;
                }
                if (shows.indexOf("hour") >= 0 && trans.hour) {
                    let number = "";
                    let text = trans.hour.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `
                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--hour">
                                <span class="ecom-collection__product-time--number">
                                    ${number}
                                </span>
                                <span class="ecom-collection__product-time--label">
                                    ${text}
                                </span>
                            </div>
                        `;
                }
                if (shows.indexOf("minute") >= 0 && trans.minute) {
                    let number = "";
                    let text = trans.minute.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--minute">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div>
                            `;
                }
                if (shows.indexOf("second") >= 0 && trans.second) {
                    let number = "";
                    let text = trans.second.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--second">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div>`;
                }

                function countdownCallback(event) {
                    let $wrapCountdown = this.closest(
                        ".ecom-collection__product-countdown-wrapper"
                    );
                    let $progressbar = $wrapCountdown.querySelector(
                            ".ecom-collection__product-countdown-progress-bar"
                        ),
                        $timer = $wrapCountdown.querySelector(
                            ".ecom-collection__product-countdown-progress-bar--timer"
                        ),
                        from = this.getAttribute("data-ecom-countdown-from") || 0;


                    this.innerHTML = event.strftime(format);
                    if ($progressbar && from) {
                        let now_time = new Date().getTime(),
                            start = new Date(from),
                            start_time = start.getTime(),
                            end_time = event.finalDate.getTime();
                        if (start_time < now_time && end_time > start_time) {
                            $progressbar.style.removeProperty("display");
                            let total = end_time - start_time;
                            let elapse = end_time - now_time;
                            let result = Math.round((elapse * 100) / total) + "%";
                            // value.innerHTML = result;
                            $timer.style.width = result;
                        } else {
                            $progressbar.style.display = "none";
                        }
                    }
                }
                function initCountdown(element) {
                    if (element.dataset.ecomCountdown) {
                        if (element.dataset.ecomCountdownFrom) {
                            if (
                                new Date().getTime() >
                                    new Date(element.dataset.ecomCountdown).getTime() &&
                                isLive
                            ) {
                                element.closest(
                                    ".ecom-collection__product-countdown-wrapper"
                                ).style.display = "none";
                                return false;
                            }
                        }
                        window.EComCountdown &&
                        window.EComCountdown(element,
                                new Date(element.dataset.ecomCountdown),
                                countdownCallback
                            )
                        element.addEventListener("stoped.ecom.countdown", () => {
                            element.closest(
                                ".ecom-collection__product-countdown-wrapper"
                            ).style.display = "none";
                        });
                    }
                }

                $el.querySelectorAll(".ecom-collection__product-countdown-time").forEach(
                    function(element) {
                        initCountdown(element);
                    }
                );

                //Loadmore
                if(isLive) {
                    const main_wrapper =  $el.querySelector(".ecom-collection__product-main");
                    let clickLoadMore = 1;
                    const handleClickLoadmore = function(e) {
                        e.preventDefault();
                        const url = this.dataset.get;
                        const wrapper = this.closest('.ecom-sections[data-section-id]');
                        const section_wrapper = $el.closest('.ecom-row.ecom-section');
                        if(!url || !wrapper || !wrapper.dataset.sectionId) return;

                        const section_id = wrapper.dataset.sectionId;
                        const fetch_url = `${url}&section_id=${section_id}`;
                        clickLoadMore++;
                        handleProgressPagination(true, clickLoadMore);
                        this.classList.add('ecom-loading');

                        handleLoadProduct(fetch_url, wrapper, this, 'loadmore', section_wrapper)
                    }

                    const handleInfiniteScroll = function(loadmore) {
                        function addObserver(el, options) {
                            let observer = new IntersectionObserver((entries, observer) => {
                                entries.forEach((entry) => {
                                    if (entry.isIntersecting) {
                                        if (options.cb) {
                                            options.cb(el);
                                        } else {
                                        handleLoad(entry.target)
                                        }
                                        observer.unobserve(entry.target);
                                    }
                                });
                            }, options);
                            observer.observe(el);
                        }

                        function handleLoad(el) {
                            const url = el.dataset.get;
                            const wrapper = el.closest('.ecom-sections[data-section-id]');
                            const section_wrapper = el.closest('.ecom-row.ecom-section');
                            if(!url || !wrapper || !wrapper.dataset.sectionId) return;

                            const section_id = wrapper.dataset.sectionId;
                            const fetch_url = `${url}&section_id=${section_id}`;
                            if(flagInfinite) {
                                $el.classList.add('ecom-doing-scroll');
                                handleLoadProduct(fetch_url, wrapper, el, 'infinite', section_wrapper)
                            }
                        }

                        addObserver(loadmore, {});

                        }

                        const handleLoadProduct = function(fetch_url, wrapper, btn, type, section_wrapper) {
                            flagInfinite = false;
                            const loadProduct = async function(url) {
                                const response = await fetch(url, {
                                method: 'GET',
                                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                                headers: {
                                    'Content-Type': 'text/html'
                                },
                                });
                                return response.text();
                            }

                            loadProduct(fetch_url).then(function(data) {
                                const dom = document.createElement('div');
                                dom.innerHTML = data;
                                const products_item = dom.querySelector('.ecom-collection__product-main.ecom-collection_product_template_collection .ecom-collection__product--wrapper-items');

                                if(!products_item) return;

                                const wrapper_products =  section_wrapper.querySelector('.ecom-collection__product--wrapper-items');
                                const loadmore_wrapper = section_wrapper.querySelector('.ecom-products-pagination-loadmore');

                                while(products_item.firstChild) {
                                    wrapper_products.appendChild(products_item.firstChild);
                                }

                                products_item.parentNode.removeChild(products_item);

                                if(type === 'loadmore') {
                                    const loadmore = dom.querySelector('.ecom-products-pagination-loadmore');
                                    if(loadmore) {
                                        loadmore_wrapper.innerHTML = loadmore.innerHTML;
                                        // loadmore_wrapper.querySelector('.ecom-products-pagination-loadmore-btn') &&
                                        // loadmore_wrapper.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                                    } else {
                                        loadmore_wrapper.remove();
                                    }
                                } else {
                                    btn.remove();

                                    const loadmore = dom.querySelector('.ecom-products-pagination-infinite');
                                    if(loadmore) {
                                        wrapper_products.after(loadmore);
                                        handleInfiniteScroll(loadmore)
                                    }
                                }
                                main_wrapper.dispatchEvent(new CustomEvent('ecom-products-init',{
                                    detail: {
                                    wrapper: main_wrapper
                                    }
                                }))
                            })
                            .finally(function() {
                                if(window.EComposer) window.EComposer.initQuickview();
                                flagInfinite = true;
                                $el.classList.remove('ecom-doing-scroll');
                                btn.classList.remove('ecom-loading')
                            })
                        }

                    if(main_wrapper && main_wrapper.dataset.pagination) {
                        const pagination = main_wrapper.dataset.pagination;

                        if(pagination === 'loadmore') {
                            $el.querySelector('.ecom-products-pagination-loadmore-btn') &&
                            $el.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                        } else if (pagination === 'infinit') {
                            const loadmore = $el.querySelector('.ecom-products-pagination-infinite');
                            if(loadmore)
                                handleInfiniteScroll(loadmore);
                        }
                    }

                    main_wrapper.addEventListener('ecom-products-init', function(e) {
                        const wrapper = e.detail.wrapper;
                        if(!wrapper) return;
                        if(main_wrapper && main_wrapper.dataset.pagination) {
                            const pagination = main_wrapper.dataset.pagination;

                            if(pagination === 'loadmore') {
                                $el.querySelector('.ecom-products-pagination-loadmore-btn') &&
                                $el.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                            } else if (pagination === 'infinit') {
                                const loadmore = $el.querySelector('.ecom-products-pagination-infinite');
                                if(loadmore) {
                                    handleInfiniteScroll(loadmore);
                                }
                            }
                        }
                        //Options selector
                        wrapper.querySelectorAll(".ecom-collection__product-variants:not(.ecom-swatch-init)").length &&
                        wrapper.querySelectorAll(".ecom-collection__product-variants:not(.ecom-swatch-init)").forEach(executeShopifyOptionSelectors);
                        //Countdown
                        wrapper.querySelectorAll(".ecom-collection__product-countdown-time").length &&
                        wrapper.querySelectorAll(".ecom-collection__product-countdown-time").forEach(
                            function(element) {
                                initCountdown(element);
                            }
                        );
                        handleQuickShopBtn(wrapper);
                        //Loadmore
                        wrapper.querySelector('.ecom-products-pagination-loadmore-btn') &&
                        wrapper.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);

                        //ATC
                        window.EComposer && typeof window.EComposer.init === 'function' && window.EComposer.init();

                        //Thrity Apps
                        initReviewApps(wrapper);

                        const $wishlistWrapper = wrapper.querySelector(
                            ".ecom-collection__product--wishlist-wrapper"
                        );
                        initWishlistApps($wishlistWrapper);
                    })
                }

                function initReviewApps($wrapper) {
                    if ($wrapper && $wrapper.dataset.reviewPlatform) {
                        switch ($wrapper.dataset.reviewPlatform) {
                            case "product-reviews":
                                if (window.SPR) {
                                    try {
                                        window.SPR.$ = window.jQuery;
                                        window.SPR.initDomEls();
                                        window.SPR.loadBadges();
                                    } catch (e) {
                                        console.info(e.message);
                                    }
                                }
                                break;
                            case "judgeme":
                                if (window.jdgm) {
                                    try {
                                        window.jdgm.batchRenderBadges();
                                    } catch (e) {
                                        console.info(e.message);
                                    }

                                        $el.querySelectorAll('[data-average-rating="0.00"]').forEach(function (e) {
                                            e.style.display = "block !important";
                                        });
                                }
                                break;
                            case "product-reviews-addon":
                                if (window.StampedFn) {
                                    window.StampedFn.loadBadges();
                                }
                                break;
                            case "lai-reviews":
                                if(typeof window.SMARTIFYAPPS !== 'undefined' && window.SMARTIFYAPPS.rv.installed){
                                    window.SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
                                }
                                break;
                            case "air-reviews":
                                if(typeof window.avadaAirReviewRerender === 'function') {
                                    window.avadaAirReviewRerender();
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }

                function initWishlistApps($wishlistWrapper) {
                    if ($wishlistWrapper) {
                        switch ($wishlistWrapper.dataset.wishlistApp) {
                            case "swym-relay":
                                if (window._swat) {
                                    window._swat.initializeActionButtons(
                                        ".ecom-collection__product-wishlist-button"
                                    );
                                }
                                break;
                            case "wishlist-hero":
                                $el.querySelectorAll(".wishlist-hero-custom-button").forEach(
                                    function (wishlistButton) {
                                        var ev = new CustomEvent(
                                            "wishlist-hero-add-to-custom-element",
                                            {
                                                detail: wishlistButton
                                            }
                                        );
                                        document.dispatchEvent(ev);
                                    }
                                );
                                break;
                            case "wishlist-wishify":
                                // var dom = document.createElement('script');
                                // dom.src = 'https://zooomyapps.com/wishlist/ListWishlistProduct.js';
                                // window.document.head.appendChild(dom);
                                break;
                            default:
                                break;
                        }
                    }
                }

                if (!isLive) {
                    const $wrapper = $el.querySelector(".ecom-collection__product-main");
                    initReviewApps($wrapper);

                    const $wishlistWrapper = $el.querySelector(
                        ".ecom-collection__product--wishlist-wrapper"
                    );
                    initWishlistApps($wishlistWrapper)
                }

                //Preload
                if(this.settings.enable_preload) {
                    var $product_list = $el.querySelectorAll('.ecom-collection__product-item');
                    $product_list.forEach(function(product) {

                        product.addEventListener('mouseenter', function() {
                            let prefetcher = document.createElement("link");
                            prefetcher.rel = "prefetch",
                            document.head.appendChild(prefetcher);
                            var link = this.querySelector('a.ecom-collection__product-item-information-title').getAttribute('href');
                            prefetcher.href = link;
                        },{ once: true})
                    })
                }

                // Compare
                if(this.settings.show_compare && !isLive) {
                    var $compare_button_list = $el.querySelectorAll('.ecom-product__compare-link');
                    $compare_button_list.forEach(function(compare_button) {
                        compare_button.addEventListener('click', function() {
                            if(this.classList.contains('ecom-product__compare-link-added'))
                                this.classList.remove('ecom-product__compare-link-added', 'ecom-button-active');
                            else
                                this.classList.add('ecom-product__compare-link-added', 'ecom-button-active');
                        })
                    })
                }
                // Wishlist
                if(this.settings.show_wishlist && !isLive) {
                    var $wishlist_button_list = $el.querySelectorAll('.ecom-product__wishlist-link');
                    $wishlist_button_list.forEach(function(wishlist_button) {
                        wishlist_button.addEventListener('click', function() {
                            if(this.classList.contains('ecom-product__wishlist-link-added'))
                                this.classList.remove('ecom-product__wishlist-link-added', 'ecom-button-active');
                            else
                                this.classList.add('ecom-product__wishlist-link-added', 'ecom-button-active');
                        })
                    })
                }
                //recommendations
                if (this.settings.show_product_by === "recommendations" && isLive) {
                        let parent = $el.closest('.ecom-builder');
                        if (parent) {
                            let sectionId = parent.querySelector('.ecom-sections').dataset.sectionId;
                            let productId = parent.querySelector('input[name="product-id"]')? parent.querySelector('input[name="product-id"]').value:"";
                            let limit = 8;
                            let section = parent.querySelector(`[data-section-id="${sectionId}"]`)
                            let productContainer = section.querySelector('.ecom-collection__product-container');
                            let productMain= section.querySelector('.ecom-collection__product-main');
                            let template = productMain.classList.contains("ecom-collection_product_template_product");
                            if (template && this.settings.show_product_by === "recommendations") {
                                limit = this.settings.limit_recommended_products;
                            }

                        fetch(`${window.EComposer.routes.root_url}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${sectionId}`)
                            .then((response) => response.text())
                                .then((text) => {
                                    const html = document.createElement('div');
                                    html.innerHTML = text;
                                    const recommendations = html.querySelector(`[data-section-id="${sectionId}"]`);
                                    const recommenProductMain = recommendations.querySelector('.ecom-collection__product-main');
                                    if (recommendations.innerHTML.trim().length) {
                                        if (productMain) {
                                            productMain.innerHTML = recommenProductMain.innerHTML;
                                            productMain.querySelector('.ecom-collection__product--wrapper-items') &&
                                            productMain.dispatchEvent(new CustomEvent('ecom-products-init',{
                                                detail: {
                                                    wrapper: productMain
                                                }
                                            }));
                                            productContainer.dispatchEvent(new CustomEvent('ecom-products-init-slider',{
                                            detail: {
                                                wrapper: productContainer
                                            }
                                            }));
                                        }
                                    }
                            })
                        .catch((e) => {
                            console.error(e);
                        });
                        }
                }

                    });
                    
                        document.querySelectorAll('.ecom-9spsw6nogb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9spsw6nogb', settings: {"show_featured_media":true,"bage_sale":"-{{sale}}%","price_type":"first_price","sale_badge_type":"percent","slider_speed":200,"layout":"grid","enable_preload":false,"show_compare":true,"show_wishlist":true},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}